module.exports = __webpack_public_path__ + "img/center_text10.7cb536df.png";